import { mapGetters, mapActions } from "vuex";
import { store } from "@checkout/store/store";
import api from "@checkout/services/api";
import router from "@checkout/router";
import localStorage from "@checkout/services/storage";
import storage from "@checkout/services/storage";
import Navigation from "@checkout/components/Partials/Navigation.vue";
import PaymentModal from "@checkout/components/Partials/PaymentModal.vue";
import Autocomplete from "@checkout/components/Partials/Autocomplete.vue";
import SingleStep from "@checkout/components/Partials/SingleStep.vue";
import StepWrapper from "@checkout/components/Partials/StepWrapper.vue";
import SolvencyPopup from "@checkout/components/Partials/SolvencyPopup.vue";
import IntlPhone from "@checkout/components/Partials/IntlPhone.vue";
import stepsMixin from "@checkout/mixins/stepsMixin";
import _ from "lodash";
import moment from "moment";
import { EventBus } from '../../EventBus';
import { transformErrors } from '@checkout/services/errors';

export default {
  name: "CheckoutStep5",

  mixins: [stepsMixin],

  components: {
    Navigation,
    PaymentModal,
    Autocomplete,
    SingleStep,
    StepWrapper,
    SolvencyPopup,
    IntlPhone
  },

  data() {
    return {
      birthdayDateLimit: moment().subtract(18, 'years').format('YYYY-MM-DD'),
      prepaid: true,
      form: {
        simType: "",
        mnp: "",
        mnpMsisdn: "",
        mnpSubscriptionType: "",
        puk: "",
        salutation: "Mrs",
        first_name: "",
        last_name: "",
        day: "",
        month: "",
        year: "",
        email: "",
        password: "",
        username: "",
        address: "",
        number: "",
        city: "",
        country: "Switzerland",
        postal_code: "",
        isTv: false,
        mobilePhone: "",
        address_id: ""
      },
      errors: {},
      salutationOverwrite: false,
      addressOverwrite: false,
      isSelectChanged: false,
      skipJumping: false,
      autocomplete: [],
      isLoading: false,
      solvent: true,
    };
  },

  computed: {
    ...mapGetters(["checkout", "steps", "isGeneralCheckout", "usePrepaidSteps"]),

    isStep4() {
      return this.$route.meta.stepNumber === "4";
    },

    isStep4a() {
      return this.$route.meta.stepNumber === "4a";
    },

    isDisabledFromEdit() {
      return this.form.hasOwnProperty('token') && !this.addressOverwrite;
    },

    isAddressIdPresent() {
      return this.form.address_id !== '';
    },
  },

  methods: {
    ...mapActions(["updatePostBill"]),

    handlePurchaseEvent() {
      this.saveCustomer();
    },

    navigateTo4a() {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");
      this.errors = {};

      api
        .post("/public-api/validate-customer", this.form)
        .then((response) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          this.$router.push({ path: '/checkout/4a' });
        })
        .catch((error) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          if (error.response.status === 422) {
            this.errors = transformErrors(error.response.data.errors);
          }

          if (error.response.data.hasOwnProperty("username")) {
            var alertContent = document.createElement('span');
            alertContent.innerHTML=this.$i18nApi.t("userExists");
            this.$swal({
              content: alertContent,
              icon: "warning",
            });
          }

          if (error.response.data.hasOwnProperty("error")) {
            this.$swal(this.$i18nApi.t("messages.error"));
          } else if (error.response.status === 400) {
            this.$swal(error.response.data.message);
          }
        });
    },

    prepareStep4() {
      api
        .get("/public-api/prepare/4/" + localStorage.get("page-step", true))
        .then((response) => {
          this.form = response.data.user;
          this.form.isTv = response.data.tv;
          this.prepaid = !response.data.postpaid;
          this.solvent = response.data.solvent;
          
          if (response.data.user.address === '') {
            this.addressOverwrite = true;
          }

          if (this.form.salutation.length === 0) {
            this.salutationOverwrite = true;
          }

          let token = localStorage.get("token", true);

          if (token !== null && typeof token !== "undefined") {
            this.form.token = token;
          }
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
          if (error.response.data.hasOwnProperty("page")) {
            storage.save("page-step", error.response.data.page, true);
            this.skipJumping = true;
            router.push("/checkout/" + error.response.data.page);
          } else {
            router.push("/checkout/1");
          }
        });
    },

    updateCustomer: function () {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

      this.form.username = this.form.email;
      this.form.country = "CH";

      this.errors = {};
    
      api
        .post("/public-api/update-customer", this.form)
        .then((response) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");

          router.push("/checkout/5");
        })
        .catch((error) => {
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
          this.$swal(this.$i18nApi.t("messages.error"));
          
          if (error.response.data.hasOwnProperty("bad-address")) {
            this.$swal(this.$i18nApi.t("badAddress"));
          }

          if (error.response.status === 422) {
            this.errors = transformErrors(error.response.data.errors);
          }
        });
    },

    /**
     * On change select input, then append darker font
     */
    appendClass() {
      this.isSelectChanged = true;
    },

    searchAddress() {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");
      this.isLoading = true;
      api
        .post("/public-api/address-population", {
          city: this.form.city,
          street: this.form.address,
          zipcode: this.form.postal_code,
          house_number: this.form.number,
        })
        .then((response) => {
          this.autocomplete.city = response.data.city;
          this.autocomplete.street = response.data.street;
          this.autocomplete.zipcode = response.data.zipcode;
          this.autocomplete.house_number = response.data.house_number;
          this.isLoading = false;
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
        })
        .catch(() => {
          this.isLoading = false;
          store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE");
        });
    },

    getBirthday() {
      if (this.form.year && this.form.month && this.form.day) {
        return `${this.form.year}-${this.form.month}-${this.form.day}`;
      }

      return "";
    },

    updateBirthday(event) {
      const date = moment(event.target.value);
      const dateLimit = moment(this.birthdayDateLimit);

      if (date > dateLimit) {
        this.errors = {
          year: {
            message: this.$i18nApi.t("birthday.limit")
          }
        }

        this.form.year = '';
        this.form.month = '';
        this.form.day = '';        
      } else {
        delete this.errors.year;

        this.form.year = date.format('YYYY');
        this.form.month = date.format('MM');
        this.form.day = date.format('DD');
      }
    },

    resetAddress() {
      this.form.postal_code = '';
      this.form.city = '';
      this.form.address = '';
      this.form.number = '';
    }
  },

  mounted() {
    EventBus.$on('purchaseEvent', this.handlePurchaseEvent);

    this.prepareStep4();
  },

  beforeDestroy() {
    EventBus.$off('purchaseEvent', this.handlePurchaseEvent);
  },

  beforeRouteLeave(to, from, next) {
    if (!this.skipJumping) {
      storage.save(
        "page-step",
        window.location.pathname.split("/").pop(),
        true
      );
    }
    next();
  },

  watch: {
    "form.city": _.debounce(function () {
      if (this.form.city === '') {
        this.resetAddress();
      }

      this.searchAddress();
    }, 500),
    "form.address": _.debounce(function () {
      if (this.form.address === '') {
        this.resetAddress();
      }

      this.searchAddress();
    }, 500),
    "form.postal_code": _.debounce(function () {
      if (this.form.postal_code === '') {
        this.resetAddress();
      } 

      this.searchAddress();
    }, 500),
    "form.number": _.debounce(function () {
      this.searchAddress();
    }, 500), 
  },
};
